import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=2d873279&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=2d873279&scoped=true&lang=css&"
import style1 from "./Header.vue?vue&type=style&index=1&id=2d873279&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d873279",
  null
  
)

export default component.exports